// import { useState } from "react";

const useRequestToken = () => {
    // const [token, setToken] = useState('');

    const getToken = (length) => {
        // if (!token) {
            // setToken(makeid(length));
        // } 
        return makeid(length);
    }

    return [
        getToken
    ]
}

const makeid = (length) => {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
   return result;
}

export default useRequestToken;